export const DEFAULT_RECEIPT_PREFIX_TEMPLATE = "MF/{yy-yy}/";
const YEAR_TOKEN = "{yy-yy}";

/** Mirrors the API rules so the form can fail fast; the API stays authoritative. */
export function validateReceiptPrefixTemplate(template: string): string | null {
  const value = template.trim();
  if (!value) return "Receipt prefix cannot be empty";
  if (value.length > 50) return "Receipt prefix must be at most 50 characters";
  const withoutToken = value.split(YEAR_TOKEN).join("");
  if (/[{}]/.test(withoutToken)) return `Only the ${YEAR_TOKEN} placeholder is supported`;
  if (withoutToken && !/^[A-Za-z0-9/\-_. ]+$/.test(withoutToken)) {
    return "Use letters, digits and / - _ . only";
  }
  return null;
}

/** Example receipt prefix for an academic year starting in `startYear` (e.g. 2026 -> MF/26-27/). */
export function previewReceiptPrefix(template: string, startYear: number): string {
  const yy = (n: number) => String(n % 100).padStart(2, "0");
  return template.split(YEAR_TOKEN).join(`${yy(startYear)}-${yy(startYear + 1)}`);
}
